import CalcEmptyListBlock from '../../../components/CalcEmptyListBlock/CalcEmptyListBlock';

const Methodology = () => {
  console.log('Templates');
  return <CalcEmptyListBlock>The functionality in development.</CalcEmptyListBlock>;
};

export default Methodology;
